import {
  Autocomplete,
  Box,
  CircularProgress,
  InputAdornment,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomPagination from "../CustomPagination";
import { authHeader } from "../../comman/MainFunction";
import { deCryptFun, enCryptFun } from "../../comman/CustomFunction";
import API from "../../comman/API";
import moment from "moment";
import { GET_CUSTOMER_ACTIVITY_TABLE } from "../../../constants/ApiRoute";
import NoRecordFound from "../../comman/NoRecordFound";

export default function ActivityTable(props) {
  const { customerTab } = props;

  const [sortedData, setSortedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  const [totalPages, setTotalPages] = useState(0);

  // Sorting state
  const [sortConfig, setSortConfig] = useState({
    key: "LogDateTime",
    direction: "asc",
  });

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleSearchChange = (event, value) => {
    setSearchQuery(value);
    setPage(1); // Reset to page 1 when search query changes
  };

  const handleSort = (key) => {
    setSortConfig((prevState) => ({
      key,
      direction:
        prevState.key === key && prevState.direction === "asc" ? "desc" : "asc",
    }));
  };

  const sortData = (data, key, direction) => {
    return data.sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
  };

  const fieldsToSearch = [
    "User",
    "Description",
    "LogDateTime",
    "LogTypeDescription",
    "TargetName",
  ];

  const getProjectActivityDetails = async (custId) => {
    setLoading(true);
    let data = {
      customerId: customerTab?.customerId ? customerTab?.customerId : custId,
    };
    const config = {
      method: "GET",
      url: GET_CUSTOMER_ACTIVITY_TABLE,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        // const sorted = sortData(data, sortConfig.key, sortConfig.direction);
        console.log(data,'sorteddddddddddddddddddd')
        const transformedData = data
        .map(item => ({
            ...item,
            // User: item.User.length > 30 ? item.User.substring(0, 30) + '...' : item.User
        }))
        .sort((a, b) => {
            // Sort by LogDateTime in descending order for recent data first
            const dateComparison = new Date(b.LogDateTime) - new Date(a.LogDateTime);
            if (dateComparison !== 0) {
                return dateComparison;
            }
            // If dates are the same, sort by OrderByThis in ascending order
            return a.OrderByThis - b.OrderByThis;
        });
    

        setSortedData(transformedData);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProjectActivityDetails(customerTab.customerId);
  }, [customerTab.customerId, sortConfig]);

  // Group data by TargetName
  const groupedData = sortedData.reduce((acc, item) => {
    const key = item.TargetName;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(item);
    return acc;
  }, {});

  // Flatten grouped data
  const flattenedArray = Object.entries(groupedData).flatMap(([key, items]) => {
    return items.map((item) => ({
      ...item,
      TargetName: key,
    }));
  });

  // Apply search filter
  const filteredData = flattenedArray.filter((item) =>
    fieldsToSearch.some((field) => {
      let fieldValue = item[field];

      // Debugging LogDateTime formatting
      if (field === "LogDateTime" && fieldValue) {
        fieldValue = moment
          .utc(new Date(fieldValue))
          .format("MM/DD/YYYY h:mm:ss A");
        console.log(`Formatted LogDateTime for Search: ${fieldValue}`);
      }

      return (
        fieldValue &&
        String(fieldValue).toLowerCase().includes(searchQuery.toLowerCase())
      );
    })
  );

  // Calculate total pages based on filtered data
  useEffect(() => {
    setTotalPages(Math.ceil(filteredData.length / rowsPerPage));
  }, [filteredData]);

  // Paginate filtered data
  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    (page - 1) * rowsPerPage + rowsPerPage
  );

  return (
    <div>
      <Stack
        sx={{ mb: "20px" }}
        direction={{ xs: "column", sm: "row", md: "row" }}
        alignItems={{ xs: "baseline", sm: "center", md: "center" }}
        justifyContent="space-between"
      >
        <Autocomplete
          sx={{ maxWidth: "265px", width: "100%" }}
          freeSolo
          id="free-solo-2-demo"
          disableClearable
          startAdornment={
            <InputAdornment position="start">
              <span className="material-symbols-outlined">search</span>
            </InputAdornment>
          }
          options={[]}
          onInputChange={handleSearchChange}
          renderInput={(params) => (
            <TextField
              placeholder="Search"
              {...params}
              InputProps={{
                ...params.InputProps,
                type: "search",
              }}
            />
          )}
        />
      </Stack>
      <TableContainer sx={{ boxShadow: "none" }} component={Paper}>
        <Table
          // sx={{ minWidth: 650 }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell>
                {/* <TableSortLabel
                  active={sortConfig.key === "LogDateTime"}
                  direction={
                    sortConfig.key === "LogDateTime"
                      ? sortConfig.direction
                      : "asc"
                  }
                  onClick={() => handleSort("LogDateTime")}
                > */}
                Date
                {/* </TableSortLabel> */}
              </TableCell>
              <TableCell>
                {/* <TableSortLabel
                  active={sortConfig.key === "User"}
                  direction={
                    sortConfig.key === "User" ? sortConfig.direction : "asc"
                  }
                  onClick={() => handleSort("User")}
                > */}
                User
                {/* </TableSortLabel> */}
              </TableCell>
              <TableCell>
                {/* <TableSortLabel
                  active={sortConfig.key === "LogTypeDescription"}
                  direction={
                    sortConfig.key === "LogTypeDescription"
                      ? sortConfig.direction
                      : "asc"
                  }
                  onClick={() => handleSort("LogTypeDescription")}
                > */}
                Type
                {/* </TableSortLabel> */}
              </TableCell>
              <TableCell>
                {/* <TableSortLabel
                  active={sortConfig.key === "Description"}
                  direction={
                    sortConfig.key === "Description"
                      ? sortConfig.direction
                      : "asc"
                  }
                  onClick={() => handleSort("Description")}
                > */}
                Description
                {/* </TableSortLabel> */}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <CircularProgress disableShrink />
                </TableCell>
              </TableRow>
            ) : paginatedData.length > 0 ? (
              paginatedData.map((val, index) => (
                <React.Fragment key={index}>
                  {index === 0 ||
                  paginatedData[index - 1].TargetName !== val.TargetName ? (
                    <TableRow>
                      <TableCell colSpan={4} sx={{ padding: "0px !important" }}>
                        <Box
                          className="datebox-title"
                          sx={{
                            padding: "13px !important",
                            borderRadius: "0px",
                          }}
                        >
                          <Typography>{val.TargetName}</Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : null}
                  <TableRow>
                    <TableCell sx={{ minWidth: "200px" }}>
                      {/* {val.LogDateTime
                        ? moment(new Date(val.LogDateTime)).format("MM/DD/YYYY")
                        : "-"} */}
                      {val.LogDateTime
                        ? moment
                            .utc(new Date(val.LogDateTime))
                            .format("MM/DD/YYYY h:mm:ss A")
                        : "-"}
                    </TableCell>
                    <TableCell>{val.User ? val.User : "-"}</TableCell>
                    <TableCell sx={{ minWidth: "170px" }}>
                      {val.LogTypeDescription ? val.LogTypeDescription : "-"}
                    </TableCell>
                    <TableCell sx={{ wordBreak: "break-word" }}>
                      {val.Description ? val.Description : "-"}
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  {/* <Typography>No Record Found</Typography> */}
                  <NoRecordFound />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {filteredData.length > 0 && (
          <Pagination
            sx={{ mt: "13.5px", float: "right" }}
            shape="rounded"
            // hidePrevButton
            // hideNextButton
            count={totalPages}
            page={page}
            onChange={handlePageChange}
          />
        )}
      </TableContainer>
    </div>
  );
}
